module.exports = __webpack_public_path__ + "static/media/kristine.af35ade1.jpg";